import { Elements } from "@stripe/react-stripe-js";
import { loadStripe, type Stripe } from "@stripe/stripe-js";
const loadStripeWithRetry = async (key: string, maxRetries = 3, delay = 1000): Promise<Stripe | null> => {
  for (let i = 0; i < maxRetries; i++) {
    try {
      const stripe = await loadStripe(key);
      return stripe;
    } catch (error) {
      if (i === maxRetries - 1) {
        throw error;
      }
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
  return null;
};
export const stripePromise = loadStripeWithRetry(
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY ?? "");

// `as const`, not an annotation: the installed Appearance type lacks `inputs`,
// which Stripe still honors, and an annotated literal fails excess-property checks.
export const stripeElementsOptions = {
  mode: "setup",
  currency: "usd",
  appearance: {
    inputs: "condensed",
    rules: {},
    variables: {
      buttonBorderRadius: "999px"
    }
  }
} as const;
export const PaymentsProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <Elements stripe={stripePromise} options={stripeElementsOptions} data-sentry-element="Elements" data-sentry-component="PaymentsProvider" data-sentry-source-file="PaymentsProvider.tsx">
      {children}
    </Elements>;
};